import React from 'react';
import { FaInfoCircle, FaListAlt, FaClipboardList, FaStickyNote, FaExclamationTriangle } from 'react-icons/fa';

const ItineraryTabs = ({ tabsRef, activeTab, scrollToSection }) => (
  <div ref={tabsRef} className="sticky-tabs-container">
    <div className="itinerary-tabs">
      <button
        className={`tab-button ${activeTab === 'overview-section' ? 'active' : ''}`}
        onClick={() => scrollToSection('overview-section')}
        aria-label="Overview section"
      >
        <FaInfoCircle /> <span className="tab-text">Overview</span>
      </button>
      <button
        className={`tab-button ${activeTab === 'itinerary-section' ? 'active' : ''}`}
        onClick={() => scrollToSection('itinerary-section')}
        aria-label="Itinerary section"
      >
        <FaListAlt /> <span className="tab-text">Itinerary</span>
      </button>
      <button
        className={`tab-button ${activeTab === 'details-section' ? 'active' : ''}`}
        onClick={() => scrollToSection('details-section')}
        aria-label="Details section"
      >
        <FaClipboardList /> <span className="tab-text">Inclusions</span>
      </button>
      <button
        className={`tab-button ${activeTab === 'notes-section' ? 'active' : ''}`}
        onClick={() => scrollToSection('notes-section')}
        aria-label="Notes section"
      >
        <FaStickyNote /> <span className="tab-text">Notes</span>
      </button>
      <button
        className={`tab-button ${activeTab === 'cancellation-section' ? 'active' : ''}`}
        onClick={() => scrollToSection('cancellation-section')}
        aria-label="Cancellation section"
      >
        <FaExclamationTriangle /> <span className="tab-text">Cancellation</span>
      </button>
    </div>
  </div>
);

export default ItineraryTabs;
